import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ tokens }) => ({
  icon40: {
    '& > div': {
      height: 40,
    },
    height: 40,
    '& img': {
      height: 40,
      width: 'auto',
    },
  },
  icon48: {
    '& > div': {
      height: 48,
    },
    height: 48,
    '& img': {
      height: 48,
      width: 'auto',
    },
  },
  icon72: {
    '& > div': {
      height: 32,
    },
    height: 72,
    '& img': {
      height: 72,
      width: 'auto',
      maxWidth: '100%',
      objectFit: 'contain',
    },
  },
  icon80: {
    '& > div': {
      height: 32,
    },
    '& img': {
      height: 80,
      width: 'auto',
      maxWidth: '100%',
      objectFit: 'contain',
    },
    height: 80,
  },

  fullErrorLogo: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: tokens.spacing['4'],
    maxHeight: 80,
    height: '100%',
    width: 'auto',
    maxWidth: '100%',
    objectFit: 'contain',
  },

  fullLogo: {
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      maxHeight: 80,
    },
    maxHeight: 80,
    '& img': {
      maxHeight: 80,
      width: '100%',
    },
  },
}));
